import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

const Return = () => {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const response = await fetch(
          "https://vantara.datacubeglobal.com/api/return-policies"
        );
        if (!response.ok) throw new Error("Failed to fetch policies");
        const data = await response.json();
        setPolicies(data.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicies();
  }, []);

  if (loading) {
    return (
      <div className="py-5 bg-white">
        <Container>
          <Row>
            <Col md={8}>
              <h2 className="mb-4">Return & Cancellation Policies</h2>
              <p>Loading policies...</p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-5 bg-white">
        <Container>
          <Row>
            <Col md={8}>
              <h2 className="mb-4">Return & Cancellation Policies</h2>
              <p className="text-danger">Error: {error}</p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <>
      <div className="py-5 bg-white">
        <Container>
          <Row>
            <Col md={8}>
              <h2 className="mb-4">Return & Cancellation Policies</h2>

              {policies.length === 0 ? (
                <p>No return policies available.</p>
              ) : (
                policies.map((policy) => (
                  <div key={policy.policy_id} className="mb-4 border-bottom">
                    {/* Policy Header (like FAQ question) */}
                    <div className="p-3">
                      <h5 className="mb-2 text-dark fw-bold">{policy.title}</h5>
                      <div className="d-flex gap-3 mb-2">
                        <span className="text-muted small">
                          Return window: <strong>{policy.return_days} days</strong>
                        </span>
                        <span className="text-muted small">
                          Type:{" "}
                          <strong>
                            {policy.return_type.replace(/_/g, " ")}
                          </strong>
                        </span>
                        {policy.is_active === 1 && (
                          <span className="text-success small fw-bold">● Active</span>
                        )}
                      </div>
                    </div>

                    {/* Policy Content (like FAQ answer) */}
                    <div className="p-3 bg-white border-top">
                      <p
                        className="mb-0"
                        style={{
                          fontSize: "18px",
                          color: "#313131FF",
                          whiteSpace: "pre-line", // Preserves line breaks from API
                        }}
                      >
                        {policy.conditions}
                      </p>
                    </div>
                  </div>
                ))
              )}
            </Col>
          </Row>
        </Container>
      </div>
      <hr />
    </>
  );
};

export default Return;